import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-mcommerce-cash-card',
  templateUrl: './mcommerce-cash-card.component.html',
  styleUrls: ['./mcommerce-cash-card.component.scss']
})
export class McommerceCashCardComponent implements OnInit {

  @Input() cash;

  constructor(private router: Router,
              private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
  }

  public gotoCheckOut() {
    this.router.navigate([this.cash.id, 'checkout'], { relativeTo: this.activatedRoute });
  }
}
